export default __webpack_public_path__ + "static/media/school-av-gif-final.14625fab.gif";